import { Component, Input, OnInit, OnDestroy } from '@angular/core';
import { NavigationExtras, Router } from '@angular/router';
import { AlertController, LoadingController, ModalController, NavController } from '@ionic/angular';
import * as moment from 'moment';
import { filter, map, take } from 'rxjs/operators';
import { mygolfUtils } from 'src/custom/mygolf2u-utils';
import {
  TeeTimeBooking,
  createAddlBookingPlayers,
  TeeTimeBookingOptions,
} from 'src/data/mygolf.data';
import { PlayerHomeInfo, PlayerInfo } from 'src/data/player-data';
import { ClubFlightService } from 'src/providers/club-flight-service/club-flight-service';
import { PlayerHomeDataService } from 'src/redux/player-home';
import { AddlBookingPlayers, BookingDetailsPage } from '../booking-details.page';
import { Subscription, Observable, from, concatMap, tap, catchError, of } from 'rxjs';
import { SUBSCRIBE_TEETIME_BOOKING, WebsocketActions } from 'src/redux/wstomp';
import { SessionActions, SessionDataService } from 'src/redux/session';
import { BookingService } from 'src/providers/tee-booking-service/tee-booking-service';

export class BookingProgressMessage {
  confirmation: string;
  inProcess: string;
  bookingDone: BookingDoneMessage;
}

export class BookingDoneMessage {
  success?: string;
  failed?: string;
  created?: string;
}
@Component({
  selector: 'app-booking-confirmation',
  templateUrl: './booking-confirmation.component.html',
  styleUrls: ['./booking-confirmation.component.scss'],
})
export class BookingConfirmationComponent implements OnInit, OnDestroy {
  @Input() clubName: string;
  @Input() courseName: string;
  @Input() teeOffDate: any;
  @Input() teeOffTime: any;
  @Input() teeTimeSlotDisplay: any;
  @Input() playerReq: any;
  @Input() holesPlayed: any;
  @Input() buggyRequired: any;
  @Input() caddyRequired: any;
  @Input() fromClub: any;
  @Input() clubBookingPlayers: any;
  @Input() userType: any;
  @Input() playerHomeInfo$: any;
  @Input() player$: any;
  @Input() bookForOther: any;
  @Input() captchaResponse: any;
  @Input() afterBook: any = false;
  @Input() currSession: any;
  @Input() clubInfo: any;
  @Input() appAttribute: any;
  @Input() message: any;
  @Input() bookingReference: string;
  @Input() addlBookingPlayers: Array<any>;
  @Input() clubId: number;
  @Input() bookingOptions: TeeTimeBookingOptions;
  bookingSuccess: boolean = false;
  constructor(
    private router: Router,
    private nav: NavController,
    private mg2uUtil: mygolfUtils,
    private alertCtrl: AlertController,
    private modalCtl: ModalController,
    private loadingCtrl: LoadingController,
    private flightService: ClubFlightService,
    private playerHomeService: PlayerHomeDataService,
    private websocketActions: WebsocketActions,
    private sessionActions: SessionActions,
    private sessionDataService: SessionDataService,
    private teeBookingService: BookingService
  ) {
    if (!this.appAttribute) {
      this.appAttribute = this.mg2uUtil
        .getAppAttribute()
        .filter(app => {
          return app.page === 'bookingDetails';
        })
        .pop();
      // console.debug("app attribute - confimration ", this.appAttribute)
    }
    console.debug('message ', this.appAttribute);
    if (
      this.appAttribute &&
      this.appAttribute.bookingProgress &&
      this.appAttribute.bookingProgress.message
    ) {
      this.bookingProgressMessage = this.appAttribute.bookingProgress.message;
    }
    if (this.appAttribute && this.appAttribute.bookingProgress) {
      this.responseDelay = this.appAttribute.bookingProgress.responseDelay
        ? this.appAttribute.bookingProgress.responseDelay
        : 1000;
    }

    this.initSubWebsocket();
    this.initAddBookingPlayers();
  }

  ngOnInit() {
    console.log(this.message, '-Message-');
  }

  async resolved(captchaResponse: string) {
    this.captchaResponse = await captchaResponse;
    this._goBookNow();
  }

  _goBookNow() {
    this.sessionActions.setNeedRefresh(true);

    let _courseId = this.teeTimeSlotDisplay.slot.startCourse.id;
    let _totalPlayers = this.playerReq; //this.teeTimeSlotDisplay.slot.maxPlayers;
    let _teeOffDate = moment(this.teeTimeSlotDisplay.slot.teeOffDate).format('YYYY-MM-DD');
    let _fromTime = moment(this.teeTimeSlotDisplay.slot.teeOffTime, 'HH:mm:ss').format('HH:mm');
    let _toTime = moment(this.teeTimeSlotDisplay.slot.teeOffTime, 'HH:mm:ss').format('HH:mm');
    let _currDateTime = moment().toISOString();
    let _ninesPlaying = parseInt(this.holesPlayed);
    let _minPlayers = this.playerReq; //this.teeTimeSlotDisplay.slot.minPlayers;
    let _maxAllowedBuggy =
      Math.floor(this.playerReq / this.teeTimeSlotDisplay.slot.maxPlayersPerBuggy) +
      (this.playerReq % this.teeTimeSlotDisplay.slot.maxPlayersPerBuggy);
    let _maxAllowedCaddy =
      Math.floor(this.playerReq / this.teeTimeSlotDisplay.slot.maxPlayersPerCaddy) +
      (this.playerReq % this.teeTimeSlotDisplay.slot.maxPlayersPerCaddy);
    let _buggyReq = this.buggyRequired;
    let _caddyReq = this.caddyRequired;
    let _toHour = parseInt(moment(_fromTime).format('HH'));
    let _toMinute = parseInt(moment(_fromTime).format('mm'));
    let _bookingName;
    let _bookingEmail;
    let _bookingPhone;
    if (this.fromClub) {
      _bookingName = this.clubBookingPlayers.playerName;
      _bookingEmail = this.clubBookingPlayers.email;
      _bookingPhone = this.clubBookingPlayers.phone;
    } else if (this.userType !== 'player') {
    } else {
      this.playerHomeInfo$ = this.playerHomeService.playerHomeInfo();
      this.player$ = this.playerHomeInfo$
        .pipe(filter(Boolean))
        .pipe(map((playerHome: PlayerHomeInfo) => playerHome.player));
      this.player$.pipe(take(1)).subscribe((player: PlayerInfo) => {
        _bookingName = player.playerName;
        _bookingEmail = player.email;
        _bookingPhone = player.phone;
      });
    }

    if (this.bookForOther) {
      let _length = this.addlBookingPlayers.length || 0;
      this.addlBookingPlayers.push(createAddlBookingPlayers(_length + 1));
    }

    let reqBookSlot = {
      courseId: _courseId,
      teeOffDate: _teeOffDate,
      teeOffTimeFrom: _fromTime,
      teeOffTimeTo: _toTime,
      totalPlayers: _totalPlayers,
      buggyRequired: _buggyReq ? _maxAllowedBuggy : 0,
      caddiesRequired: _caddyReq ? _maxAllowedCaddy : 0,
      ninesPlaying: _ninesPlaying,
      bookingName: _bookingName,
      bookingEmail: _bookingEmail,
      bookingPhone: _bookingPhone,
      bookingRequestedAt: null,
      addBookingPlayer: this.fromClub ? true : !this.bookForOther,
    };
    if (this.fromClub) {
      this.flightService.clubBookingSlot(reqBookSlot, true, this.captchaResponse).subscribe(
        async (data: any) => {
          this.bookingSuccess = true;
          let _body = data._body;
          let _message = `Before making payment you will need to add players and complete all mandatory options.`;
          if (data.status === 200) {
            let _booking: TeeTimeBooking = data;
            this.afterBook = true;
            let params: NavigationExtras = {
              // replaceUrl: false,
              state: {
                teeSlotNew: false,
                teeTimeSlotDisplay: this.teeTimeSlotDisplay,
                bookingSlot: _booking,
                clubInfo: _booking.clubData,
                fromClub: true,
                needRefresh: true,
                currSession: this.currSession,
              },
            };
            this.router.navigate(['booking-details'], params);
          } else if (data && data.status !== 200) {
            let _error = data;
            let _msg = 'Something has happened, please try again.';
            _msg =
              _error && _error.errors && _error.errors.length > 0 ? _error.errors[0] : _error.error;

            let alert = await this.alertCtrl.create({
              header: 'Ooops',
              message: _msg,
              buttons: ['Close'],
            });
            alert.present();
            this.captchaResponse = null;
          } else {
            let alert = await this.alertCtrl.create({
              header: 'Ooops',
              message: 'Something has happened, please try again.',
              buttons: ['Close'],
            });
            alert.present();
            this.captchaResponse = null;
          }
        },
        async error => {
          let _error = error;
          this.captchaResponse = null;
          let _msg =
            _error && _error.errorCode
              ? _error.errorMessage
              : 'Something has happened, please try again or contact myGolf2u admin.';

          if (!_error.status) {
            let alert = await this.alertCtrl.create({
              header: 'Ooops',
              message: 'Something has happened, please try again.',
              buttons: ['Close'],
            });
            alert.present();
          } else {
            let alert = await this.alertCtrl.create({
              header: _error && _error.errorCode ? _error.errorCode : 'Ooops',
              message: _msg,
              buttons: ['Close'],
            });
            alert.present();
          }
        }
      );
    } else if (0 && this.userType === 'booking_agent') {
      this.flightService.bookTeeTimeSlot(reqBookSlot, false, this.captchaResponse).subscribe(
        async (data: any) => {
          this.bookingSuccess = true;
          let _body = data._body;
          let _message = `Before making payment you will need to add players and complete all mandatory options.`;
          if (data.status === 200) {
            let loader = await this.loadingCtrl.create({
              spinner: 'crescent',
              showBackdrop: false,
              duration: 30000,
              message: 'Getting booking info...',
            });
            loader.present().then(() => {
              setTimeout(() => {
                this.flightService
                  .getBookingByReference(this.clubInfo.clubId, _body)
                  .subscribe((resp: any) => {
                    let _booking: TeeTimeBooking = resp;
                    this.afterBook = true;
                    let params: NavigationExtras = {
                      replaceUrl: false,
                      state: {
                        teeSlotNew: false,
                        teeTimeSlotDisplay: this.teeTimeSlotDisplay,
                        bookingSlot: _booking,
                        clubInfo: _booking.clubData,
                        fromClub: true,
                        needRefresh: true,
                        currSession: this.currSession,
                        userType: this.userType,
                      },
                    };
                    this.router.navigate(['booking-details'], params);
                  });
              }, 30000);
            });
          } else if (data && data.status !== 200) {
            let _error = data;
            let _msg = 'Something has happened, please try again.';
            _msg =
              _error && _error.errors && _error.errors.length > 0 ? _error.errors[0] : _error.error;

            let alert = await this.alertCtrl.create({
              header: 'Ooops',
              message: _msg,
              buttons: ['Close'],
            });
            alert.present();
            this.captchaResponse = null;
          } else {
            let alert = await this.alertCtrl.create({
              header: 'Ooops',
              message: 'Something has happened, please try again.',
              buttons: ['Close'],
            });
            alert.present();
            this.captchaResponse = null;
          }
        },
        async error => {
          let _error = error;
          this.captchaResponse = null;
          let _msg =
            _error && _error.errorCode
              ? _error.errorMessage
              : 'Something has happened, please try again or contact myGolf2u admin.';

          if (!_error.status) {
            let alert = await this.alertCtrl.create({
              header: 'Ooops',
              message: 'Something has happened, please try again.',
              buttons: ['Close'],
            });
            alert.present();
          } else {
            let alert = await this.alertCtrl.create({
              header: _error && _error.errorCode ? _error.errorCode : 'Ooops',
              message: _msg,
              buttons: ['Close'],
            });
            alert.present();
          }
        }
      );
    } else {
      this.sessionDataService.getNeedRefresh().subscribe(needRefresh => {
        console.debug('session view did enter [confirming] ', needRefresh);
        if (needRefresh) {
        }
      });
      this.flightService
        .bookTeeTimeSlot(reqBookSlot, !this.bookForOther, this.captchaResponse)
        .subscribe(
          async (data: any) => {
            this.bookingReference = data;
            this.bookingSuccess = true;

            this.requestedBookingReference = data;

            let _filtered = this.bookedInfoList
              .filter(bi => {
                return bi && bi.bookingReference === data;
              })
              .pop();
            if (_filtered && _filtered.length === 1) {
              if (_filtered.action === 'booked') {
                this.progressStatus = 'success';
                this.bookingSteps = '3';
                this.bookedInfo = {
                  action: data.action,
                  clubId: data.clubId,
                  clubName: data.clubName,
                  courseName: data.courseName,
                  bookingReference: data.bookingReference,
                  teeOffDate: data.teeOffDate,
                  teeOffTime: data.teeOffTime,
                };
              } else if (_filtered.action === 'bookingFailed') {
                this.progressStatus = 'failed';
                this.bookingSteps = '3';
                this.bookedInfo = {
                  action: data.action,
                  bookingReference: data.bookingReference,
                  clubId: data.clubId,
                  failMessage: data.failMessage,
                };
              }
            }
            this.initSubWebsocket();

            console.debug(
              'go process add additional players [111]',
              this.addlBookingPlayers,
              this.bookedSlot
            );
            setTimeout(() => {
              this.checkExistingByBookingReference(data)
                .then((result: any) => {
                  this.afterBook = true;
                  this.bookingSteps = '3';
                  console.debug('booked a slot [2]', result);
                  if (result?.success) {
                    this.progressStatus = 'success';
                    this.bookedSlot = result?.data;
                  } else {
                    this.progressStatus = 'failed';
                    this.bookingSteps = '3';
                  }
                })
                .catch(error => {
                  this.progressStatus = 'failed';
                  this.bookingSteps = '3';
                });
            }, this.responseDelay);
            // let _body = data._body;
            // let _message =
            //   `Thank you for booking with myGolf2u.<br> Please see 'My Bookings' for details.` +
            //   `<br>Your booking reference : <br><b>` +
            //   _body +
            //   `</b>` +
            //   `<br>
            // Before making payment you will need to add players and complete all mandatory options.`;
            // let _title = 'Booking In Process';
            // let _okTxt = 'Go to My Bookings';
            // let _closeTxt = 'Close';
            // if (this.userType === 'booking_agent')
            //   _closeTxt = 'Continue Booking';
            // if (this.appAttribute && this.appAttribute.bookingRequest) {
            //   let _bookingRequest = this.appAttribute.bookingRequest;
            //   _message = _bookingRequest.message;
            //   _title = _bookingRequest.title;
            //   _okTxt = _bookingRequest.Ok;
            // }
            // if (!!data) {
            //   let _buttons = [];
            //   if (this.fromClub) {
            //     _buttons = [
            //       {
            //         text: 'Close',
            //         handler: () => {
            //           this.afterBook = true;
            //           this.nav.pop();
            //         },
            //       },
            //     ];
            //   } else {
            //     _buttons = [
            //       {
            //         text: _closeTxt,
            //         handler: () => {
            //           this.afterBook = true;
            //           this.nav.pop();
            //         },
            //       },
            //       {
            //         text: _okTxt,
            //         handler: () => {
            //           if (this.userType === 'booking_agent') {
            //             let _teeOffDate =
            //               this.teeTimeSlotDisplay.slot.teeOffDate;
            //             let _teeOffTime =
            //               this.teeTimeSlotDisplay.slot.teeOffTime;
            //             let _currentDate = moment().format('YYYY-MM-DD');
            //             let _partnerInfo = this.mg2uUtil.getPartnerInfo();
            //             let params: NavigationExtras = {
            //               replaceUrl: false,
            //               state: {
            //                 partnerId: _partnerInfo ? _partnerInfo.id : null,
            //                 partnerInfo: _partnerInfo ? _partnerInfo : null,
            //                 type: 'booking_agent',
            //                 startDate: _teeOffDate,
            //                 endDate: _teeOffDate,
            //                 slotFrom: _teeOffTime,
            //                 slotTo: _teeOffTime,
            //                 bookingStart: _currentDate,
            //               },
            //             };
            //             this.router.navigate(['partner-booking-list'], params);
            //           } else {
            //             let params: NavigationExtras = {
            //               replaceUrl: false,
            //               state: {
            //                 fromBookNow: true,
            //                 userType: 'player',
            //                 club: this.mg2uUtil.getSelectedClub()
            //                   ? this.mg2uUtil.getSelectedClub()
            //                   : null,
            //               },
            //             };
            //             this.router.navigate(['tabs/booking-home'], params);
            //           }
            //         },
            //       },
            //     ];
            //   }
            //   let alert = await this.alertCtrl.create({
            //     header: _title,
            //     message: _message,
            //     buttons: _buttons,
            //   });
            //   alert.present();
            // } else {
            //   this.captchaResponse = null;
            //   let alert = await this.alertCtrl.create({
            //     header: 'Ooops',
            //     message: 'Something has happened, please try again.',
            //     buttons: ['Close'],
            //   });
            //   alert.present();
            // }
          },
          async error => {
            let _error = error;
            this.captchaResponse = null;
            if (!error.status) {
              let alert = await this.alertCtrl.create({
                header: 'Ooops',
                message: 'Something has happened, please try again.',
                buttons: ['Close'],
              });
              alert.present();
            } else {
              let alert = await this.alertCtrl.create({
                header: 'Ooops',
                message:
                  _error && _error.errors[0]
                    ? _error.errors[0]
                    : 'Something has happened, please try again.',
                buttons: ['Close'],
              });
              alert.present();
            }
          }
        );
    }
  }

  bookedSlot: TeeTimeBooking;
  async redirectToMyBookings() {
    this.teeBookingService.setBookingDoneClicked(true);
    this.modalCtl.dismiss({
      success: true,
      page: 'booking-home',
    });
    if (this.userType === 'booking_agent') {
      let _teeOffDate = this.teeTimeSlotDisplay.slot.teeOffDate;
      let _teeOffTime = this.teeTimeSlotDisplay.slot.teeOffTime;
      let _currentDate = moment().format('YYYY-MM-DD');
      let _partnerInfo = this.mg2uUtil.getPartnerInfo();
      let params: NavigationExtras = {
        replaceUrl: false,
        state: {
          partnerId: _partnerInfo ? _partnerInfo.id : null,
          partnerInfo: _partnerInfo ? _partnerInfo : null,
          type: 'booking_agent',
          startDate: _teeOffDate,
          endDate: _teeOffDate,
          slotFrom: _teeOffTime,
          slotTo: _teeOffTime,
          bookingStart: _currentDate,
        },
      };
      this.router.navigate(['partner-booking-list'], params);
    } else {
      let params: NavigationExtras = {
        replaceUrl: false,
        state: {
          fromBookNow: true,
          userType: 'player',
          club: this.mg2uUtil.getSelectedClub() ? this.mg2uUtil.getSelectedClub() : null,
        },
      };
      this.router.navigate(['booking-home'], params);
    }
  }

  dismiss(type: string) {
    this.modalCtl.dismiss({
      success: false,
      page: 'booking-list',
      optionSelected: type,
    });
  }

  async continue() {
    let _params: NavigationExtras = {
      replaceUrl: false,
      state: {
        teeSlotNew: false,
        teeTimeSlotDisplay: this.bookedSlot?.slotAssigned,
        bookingSlot: this.bookedSlot,
        clubInfo: this.bookedSlot?.clubData,
        fromClub: true,
        currSession: this.currSession,
      },
    };

    this.teeBookingService.setBookingDoneClicked(true);
    this.modalCtl.dismiss({
      success: true,
      page: 'booking-list',
      params: _params,
    });
    // .then(async () => {

    //   this.router.navigate(['booking-list'], _params);
    // })
    // this.modalCtl.dismiss().then(()=>{
    //   // this.router.navigate(['booking-list']);
    //   this.nav.pop();
    // })
  }

  goBack() {
    this.modalCtl.dismiss();
    // this.modalCtl.dismiss().then(()=>{
    //   // this.router.navigate(['booking-list']);
    //   this.nav.pop();
    // })
  }

  checkExistingByBookingReference(bookingReference: string) {
    return new Promise((resolve, reject) => {
      console.debug('check existing reference ', this.clubInfo, bookingReference);
      let _clubId = this.clubInfo?.clubId || this.clubInfo?.id;

      if (!bookingReference) reject('no booking reference');
      this.flightService.getBookingByReference(_clubId, bookingReference).subscribe(
        (data: TeeTimeBooking) => {
          if (data) {
            resolve({
              success: true,
              data: data,
            });
          } else reject('not exists');
        },
        error => {
          reject({
            success: false,
            message: error?.errorMessage,
          });
        }
      );
    });
  }

  subAddPlayers: Subscription;
  // async onProcessAddAdditionalPlayers(playerA: AddlBookingPlayers, bookingId: number, idx?: number) {
  //   return new Promise((resolve, reject) => {

  //     if(this.subAddPlayers) {
  //       resolve({
  //         status: 'success',
  //         idx: idx,
  //         done: idx === this.addlBookingPlayers.length - 1 ? true : false
  //       })
  //     }

  //     // if (!data?.data?.playerDetails) data.data.playerDetails = {};
  //     // data.data.playerDetails['walking'] = this.buggyRequired
  //     //   ? !this.buggyRequired
  //     //   : true;
  //     // data.data.playerDetails['caddySelectionCriteria'] = {};
  //     // data.data.playerDetails['caddySelectionCriteria']['caddyRequired'] =
  //     //   this.caddyRequired ? this.caddyRequired : false;
  //     console.debug("adding player - ", idx, this.addlBookingPlayers[idx])
  //     let player = this.addlBookingPlayers[idx];
  //     let _playerInfo = {
  //       playerDetails: {},
  //       new: player.player ? false : true,
  //       id: player.player ? player.player.id : null,
  //       playerId: player.player ? player.player.id : null,
  //     };
  //     _playerInfo.playerDetails = {
  //       playerName: player?.playerName,
  //       email: '',
  //       gender: 'M',
  //       phone: '',
  //       walking: this.buggyRequired ? !this.buggyRequired : true,
  //       caddySelectionCriteria: {},
  //       playerContact: {},
  //     }
  //     _playerInfo.playerDetails['caddySelectionCriteria']['caddyRequired'] = this.caddyRequired ? this.caddyRequired : false;
  //     // idx += 1;

  //     this.subAddPlayers = this.flightService.addPlayerToBooking(bookingId, _playerInfo)
  //       .subscribe((data: any) => {
  //         console.debug("adding player - ", data, idx, this.addlBookingPlayers.length, _playerInfo)
  //         if (data) {
  //           if(this.subAddPlayers) {
  //             this.subAddPlayers.unsubscribe();
  //             this.subAddPlayers = null;
  //           }
  //           resolve({
  //             status: 'success',
  //             idx: idx,
  //             done: idx === this.addlBookingPlayers.length - 1 ? true : false
  //           })
  //         }
  //       }, (error) => {

  //         if(this.subAddPlayers) {
  //           this.subAddPlayers.unsubscribe();
  //           this.subAddPlayers = null;
  //         }
  //         reject({
  //           status: 'failed',
  //           idx: idx,
  //           done: idx === this.addlBookingPlayers.length - 1 ? true : false,
  //           error: error
  //         })
  //       })
  //   })
  // }

  // goProcessAddAdditionalPlayers(bookingId: number, counter: number = 0, data?: any, bookQuit?: boolean) {
  //   return new Promise((resolve, reject) => {
  //     this.onProcessAddAdditionalPlayers(null, bookingId, counter)
  //       .then((result: any) => {
  //         console.debug("on process add player : ", result, counter, this.addlBookingPlayers?.length, this.addlBookingPlayers)
  //         counter += 1;
  //         if (result.done) {
  //           console.debug("on process add player DONE : ", data)
  //           let _params: NavigationExtras = {
  //             replaceUrl: false,
  //             state: {
  //               teeSlotNew: false,
  //               teeTimeSlotDisplay: data?.bookingSlot?.slotAssigned,
  //               bookingSlot: data?.bookingSlot,
  //               clubInfo: data?.bookingSlot?.clubData,
  //               fromClub: true,
  //               currSession: this.currSession,
  //             }
  //           };
  //           // if (bookQuit) {
  //           //   this.router.navigate(['booking-list'], _params);
  //           // } else this.router.navigate(['booking-home'], _params);
  //           resolve({
  //             status: 'success',
  //             done: true
  //           })
  //         } else {
  //           this.goProcessAddAdditionalPlayers(bookingId, counter, data, bookQuit)
  //         }
  //       }).catch((error) => {

  //       });
  //   });
  // }

  async goProcessAddAdditionalPlayers(
    bookingId: number,
    counter: number = 0,
    data?: any,
    bookQuit?: boolean
  ) {
    // Check if we've reached the end of the array
    if (counter >= this.playerReq - 1) {
      // this.addlBookingPlayers?.length
      console.debug('All players processed. DONE:', data);
      return {
        status: 'success',
        done: true,
      };
    }

    try {
      // Process the current player
      const result: any = await this.onProcessAddAdditionalPlayers(null, bookingId, counter);
      console.debug(
        'on process add player:',
        result,
        counter,
        this.addlBookingPlayers?.length,
        this.addlBookingPlayers
      );

      // If this was the last player, handle completion
      if (result.done) {
        console.debug('on process add player DONE:', data);
        let _params: NavigationExtras = {
          replaceUrl: false,
          state: {
            teeSlotNew: false,
            teeTimeSlotDisplay: data?.bookingSlot?.slotAssigned,
            bookingSlot: data?.bookingSlot,
            clubInfo: data?.bookingSlot?.clubData,
            fromClub: true,
            currSession: this.currSession,
          },
        };
        return {
          status: 'success',
          done: true,
        };
      }

      // Process the next player recursively
      return await this.goProcessAddAdditionalPlayers(bookingId, counter + 1, data, bookQuit);
    } catch (error) {
      console.error('Error processing player:', error);
      return {
        status: 'failed',
        error: error,
      };
    }
  }

  async onProcessAddAdditionalPlayers(
    playerA: AddlBookingPlayers,
    bookingId: number,
    idx?: number
  ) {
    return new Promise((resolve, reject) => {
      // Make sure we unsubscribe from any existing subscription
      // if (this.subAddPlayers) {
      //   this.subAddPlayers.unsubscribe();
      //   this.subAddPlayers = null;
      // }

      // Validate index is within bounds
      if (idx < 0) {
        reject({
          status: 'failed',
          idx: idx,
          error: new Error('Invalid player index'),
        });
      }
      if (idx >= this.playerReq - 1) {
        resolve({
          status: 'success',
          idx: idx,
          done: idx === this.addlBookingPlayers.length - 1 ? true : false,
        });
        return;
      }

      console.debug('adding player -', idx, this.addlBookingPlayers[idx]);
      let player = this.addlBookingPlayers[idx];
      let _playerInfo = {
        playerDetails: {},
        new: player.player ? false : true,
        id: player.player ? player.player.id : null,
        playerId: player.player ? player.player.id : null,
      };
      _playerInfo.playerDetails = {
        playerName: player?.playerName,
        email: '',
        gender: 'M',
        phone: '',
        walking: this.buggyRequired ? !this.buggyRequired : true,
        caddySelectionCriteria: {},
        playerContact: {},
      };
      _playerInfo.playerDetails['caddySelectionCriteria']['caddyRequired'] = this.caddyRequired
        ? this.caddyRequired
        : false;

      // this.subAddPlayers =
      this.flightService.addPlayerToBooking(bookingId, _playerInfo).subscribe({
        next: (data: any) => {
          console.debug('adding player -', data, idx, this.addlBookingPlayers.length, _playerInfo);
          if (data) {
            if (this.subAddPlayers) {
              this.subAddPlayers.unsubscribe();
              this.subAddPlayers = null;
            }
            resolve({
              status: 'success',
              idx: idx,
              done: idx === this.addlBookingPlayers.length - 1 ? true : false,
            });
          }
        },
        error: error => {
          console.error('Error adding player:', error);
          if (this.subAddPlayers) {
            this.subAddPlayers.unsubscribe();
            this.subAddPlayers = null;
          }
          reject({
            status: 'failed',
            idx: idx,
            done: idx === this.addlBookingPlayers.length - 1 ? true : false,
            error: error,
          });
        },
      });
    });
  }

  bookingSub: Subscription;
  bookedInfo: any;

  toggleCard: Array<boolean> = [true];
  responseDelay: number = 500;

  timeBookingConfirmed: string;
  timeBookingDone: string;
  bookedInfoList: Array<any> = [];
  bookingSteps: string = '1';

  requestedBookingReference: string = '';
  bookingProgressMessage: BookingProgressMessage;
  progressStatus: string = 'new';
  startTime: string;
  endTime: string;
  startCourse: any;
  subCheckExistingBooking: Subscription;
  initSubWebsocket() {
    if (this.bookingSub) return;
    this.bookingSub = this.websocketActions
      .subscribeTo(SUBSCRIBE_TEETIME_BOOKING)
      .subscribe((data: any) => {
        let _clubId = this.clubId || this.clubInfo?.clubId || this.clubInfo?.id;
        setTimeout(() => {
          this.timeBookingDone = moment().format('YYYY-MM-DD hh:mm:ss A');
          if (data && Number(data.clubId) === Number(_clubId)) {
            this.bookedInfoList.push(data);
            console.debug(
              'sub to websocket : ',
              moment().format('YYYY-MM-DD HH:mm:ss'),
              data,
              String(data.bookingReference).trim() === String(this.requestedBookingReference).trim()
            );
            if (String(data.bookingReference).trim() === String(this.bookingReference).trim()) {
              this.afterBook = true;
              this.bookingSteps = '3';
              this.toggleCard[0] = false;
              if (data.action === 'booked') {
                this.progressStatus = 'success';
                this.bookedInfo = {
                  action: data.action,
                  clubId: data.clubId,
                  clubName: data.clubName,
                  courseName: data.courseName,
                  bookingReference: data.bookingReference,
                  teeOffDate: data.teeOffDate,
                  teeOffTime: data.teeOffTime,
                };
                console.debug(
                  'go process add additional players',
                  this.addlBookingPlayers,
                  this.bookedSlot
                );
                // if (this.subCheckExistingBooking) return;
                this.checkExistingByBookingReference(this.bookingReference).then((result: any) => {
                  console.debug('booked a slot [2]', result);
                  if (result?.success) {
                    this.bookedSlot = result?.data;
                    console.debug(
                      'adding bulk players',
                      this.addlBookingPlayers,
                      this.bookedSlot,
                      this.playerReq
                    );
                    // if (this.addlBookingPlayers?.length > 0) {
                    //   this.subCheckExistingBooking = this.NEWgoProcessBulkAddPlayer().subscribe({
                    //     next: () => {
                    //     },
                    //     error: error => {

                    //       if(this.subCheckExistingBooking) {
                    //         this.subCheckExistingBooking.unsubscribe();
                    //         this.subCheckExistingBooking = null;
                    //       }
                    //     },
                    //     complete: () => {

                    //       if(this.subCheckExistingBooking) {
                    //         this.subCheckExistingBooking.unsubscribe();
                    //         this.subCheckExistingBooking = null;
                    //       }
                    //     },
                    //   });
                    // }
                  }
                });
              } else if (data.action === 'bookingFailed') {
                this.progressStatus = 'failed';
                this.bookedInfo = {
                  action: data.action,
                  bookingReference: data.bookingReference,
                  clubId: data.clubId,
                  failMessage: data.failMessage,
                };
              }
              console.debug(
                'sub to websocket [inside ]: ',
                this.progressStatus,
                this.bookedInfo,
                this.bookingSteps
              );
            }
          }
        }, this.responseDelay);
        console.debug(
          'booking sub ',
          moment().format('YYYY-MM-DD HH:mm:ss'),
          data,
          this.clubInfo,
          _clubId,
          this.requestedBookingReference,
          this.progressStatus,
          this.bookingSteps
        );
      });
  }

  sendBookingMessage(type: string) {
    let _clubId = this.clubInfo.clubId;
    let _bookingReference = this.requestedBookingReference;
    let _params = {
      teeOfDate: this.teeOffDate,
      teeOfTimeFrom: this.startTime,
      teeOfTimeTo: this.endTime,
      courseId: this.startCourse.courseId,
    };
    this.flightService
      .testSendBookingProgress(type, _clubId, _bookingReference, _params)
      .subscribe(data => {
        console.debug('send message : ', data);
      });
  }

  isBookingAgent() {
    return this.mg2uUtil.getUserType() === 'booking_agent';
  }

  getMessages(type: string) {
    // console.debug("get messages ", this.bookingProgressMessage)
    // console.debug("message booking done ", this.bookingProgressMessage, this.progressStatus, this.bookedInfo, type )
    if (!this.bookingProgressMessage) return '';
    let _message = '';
    let _bookingProcessMessage = this.bookingProgressMessage;
    switch (type) {
      case 'confirmation':
        // _message = `Please ensure you select all options such as package, whom you are playing with, number of buggies, caddies etc. before you make payment.`
        _message = `Above is your booking information. Would you like to confirm your booking?`;
        if (_bookingProcessMessage.confirmation) _message = _bookingProcessMessage.confirmation;
        return _message;
      case 'inProcess':
        _message =
          `Your booking request has been submitted. Please wait for the confirmation message and/or you may check ` +
          `<b>My Booking's</b> ` +
          `for details<br>`;
        if (_bookingProcessMessage.inProcess) _message = _bookingProcessMessage.inProcess;
        return _message;
      case 'bookingDone':
        if (
          _bookingProcessMessage.bookingDone &&
          (_bookingProcessMessage.bookingDone.success?.length > 0 ||
            _bookingProcessMessage.bookingDone.failed?.length > 0)
        ) {
          if (this.progressStatus === 'success') {
            if (this.bookingOptions?.confirmationRequired) {
              _message = _bookingProcessMessage.bookingDone.created;
            } else {
              _message = _bookingProcessMessage.bookingDone.success;
            }
          } else if (this.progressStatus === 'failed') {
            if (this.bookedInfo && this.bookedInfo.failMessage)
              _message =
                this.bookedInfo.failMessage + '<br>' + _bookingProcessMessage.bookingDone.failed;
            else _message = _bookingProcessMessage.bookingDone.failed;
          } else _message = 'Still in Process';
        } else {
          if (this.progressStatus === 'success')
            _message =
              "Booking Successful! Please find your booking information below. You may proceed with your booking(s) in <b>My Booking's</b> page";
          // This is your booking reference : <b>'+this.requestedBookingReference + '</b>.
          else if (this.progressStatus === 'failed') {
            if (this.bookedInfo && this.bookedInfo.failMessage)
              _message = this.bookedInfo.failMessage; // + '<br>Please try another booking'
            else _message = 'Booking Failed. Please try another booking';
          } else _message = 'Still in Process';
        }
        return _message;
    }
  }

  goToThisBooking() {
    this.getBookingDetailsByReference().then(async (result: any) => {
      if (result && result.bookingDetails) {
        this.teeBookingService.setBookingDoneClicked(true);
        this.modalCtl
          .dismiss({
            success: true,
            page: 'booking-details',
            bookedInfo: this.bookedInfo,
            bookingDetails: result.bookingDetails,
          })
          .then(async () => {
            // const bookingDetails: any = await this.modalCtl.create({
            //   component: BookingDetailsPage,
            //   cssClass: 'full-screen-modal',
            //   componentProps: {
            //     clubInfo: result.bookingDetails.clubData,
            //     teeSlotNew: false,
            //     teeTimeSlotDisplay: result.bookingDetails.slotAssigned,
            //     bookingSlot: result.bookingDetails,
            //     modalMode: true,
            //   }
            // });

            // bookingDetails.onDidDismiss().then((data: any) => {
            //     console.debug("booking dismiss", data);
            // });

            // bookingDetails.present();

            let _navigationExtras = {
              // replaceUrl: false,
              state: {
                clubInfo: result.bookingDetails.clubData,
                teeSlotNew: false,
                teeTimeSlotDisplay: result.bookingDetails.slotAssigned,
                bookingSlot: result.bookingDetails,
              },
            };
            this.router.navigate(['booking-details'], _navigationExtras);
          });

        // this.nav.push(BookingDetailsPage, {
        //     teeSlotNew: false,
        //     teeTimeSlotDisplay: result.bookingDetails.slotAssigned,
        //     bookingSlot: result.bookingDetails,
        //     clubInfo: result.bookingDetails.clubData,
        //     fromClub: this.isBookingAgent()?true:false,
        //     fromPartner: this.isBookingAgent()?true:false,
        // });
      }
    });
  }

  getBookingDetailsByReference() {
    return new Promise((resolve, reject) => {
      let _clubId =
        this.bookedInfo?.clubId ||
        this.bookedInfo?.clubData?.id ||
        this.clubInfo?.clubId ||
        this.clubInfo?.id;
      let _bookingReference = this.bookedInfo?.bookingReference || this.bookingReference;
      this.flightService
        .getBookingByReference(_clubId, _bookingReference)
        .subscribe(bookingDetails => {
          if (bookingDetails) {
            resolve({
              status: 'success',
              bookingDetails: bookingDetails,
            });
          }
        });
    });
  }

  ionViewDidLeave() {
    if (this.bookingSub) {
      this.bookingSub.unsubscribe();
      this.bookingSub = null;
    }
    if (this.subGetBookingDoneClicked) {
      this.subGetBookingDoneClicked.unsubscribe();
      this.subGetBookingDoneClicked = null;
    }
    this.teeBookingService.setBookingDoneClicked(false);
  }

  ngOnDestroy() {
    if (this.bookingSub) {
      this.bookingSub.unsubscribe();
      this.bookingSub = null;
    }
    if (this.subGetBookingDoneClicked) {
      this.subGetBookingDoneClicked.unsubscribe();
      this.subGetBookingDoneClicked = null;
    }
    this.teeBookingService.setBookingDoneClicked(false);
  }

  NEWgoProcessBulkAddPlayer(): Observable<any> {
    return from(this.addlBookingPlayers).pipe(
      concatMap((addlBookingPlayer, index) =>
        this.NEWgoAddPlayer(addlBookingPlayer).pipe(
          tap(data => {}),
          catchError(error => {
            return of(null);
          })
        )
      ),
      tap({
        complete: () => {},
      }),
      catchError(error => {
        return of(null);
      })
    );
    // return new Observable(obs => {
    //   try {
    //     if (this.NEWonProcessAddPlayer(this.addlBookingPlayers[0], 0)) {
    //       obs.next();
    //       obs.complete();
    //     }
    //   } catch (error) {
    //     obs.error(error);
    //     if (this.subCheckExistingBooking) {
    //       this.subCheckExistingBooking.unsubscribe();
    //       this.subCheckExistingBooking = null;
    //     }
    //   }
    // });
  }

  // NEWonProcessAddPlayer(addlBookingPlayer, counter: number = 0) {
  //   if (counter >= this.addlBookingPlayers.length) {
  //     if (this.subCheckExistingBooking) {
  //       this.subCheckExistingBooking.unsubscribe();
  //       this.subCheckExistingBooking = null;
  //     }
  //     return true;
  //   }

  //   const _next = counter + 1;
  //   this.NEWgoAddPlayer(addlBookingPlayer)
  //     .then((result: any) => {
  //       this.NEWonProcessAddPlayer(this.addlBookingPlayers[_next], _next);
  //     })
  //     .catch((error: any) => {
  //       this.NEWonProcessAddPlayer(this.addlBookingPlayers[_next], _next);
  //     });
  // }

  NEWgoAddPlayer(addlBookingPlayer) {
    // return new Promise((resolve, reject) => {
    let player = addlBookingPlayer;
    let _playerInfo = {
      playerDetails: {},
      new: player.player ? false : true,
      id: player.player ? player.player.id : null,
      playerId: player.player ? player.player.id : null,
    };
    _playerInfo.playerDetails = {
      playerName: player?.playerName,
      email: '',
      gender: 'M',
      phone: '',
      walking: this.buggyRequired ? !this.buggyRequired : true,
      caddySelectionCriteria: {},
      playerContact: {},
    };
    _playerInfo.playerDetails['caddySelectionCriteria']['caddyRequired'] = this.caddyRequired
      ? this.caddyRequired
      : false;
    return this.flightService.addPlayerToBooking(this.bookedSlot?.id, _playerInfo).pipe(
      tap(data => {}),
      catchError(error => {
        throw error;
      })
    );
    // .subscribe({
    //   next: (data: any) => {
    //     // console.debug('adding player -', data, idx, this.addlBookingPlayers.length, _playerInfo);
    //     // if (data) {
    //     //   resolve({
    //     //     status: 'success',
    //     //     // idx: idx,
    //     //     // done: idx === this.addlBookingPlayers.length - 1 ? true : false,
    //     //   });
    //     // }
    //   },
    //   error: error => {
    //     console.error('Error adding player:', error);
    //     // reject({
    //     //   status: 'failed',
    //     //   // idx: idx,
    //     //   // done: idx === this.addlBookingPlayers.length - 1 ? true : false,
    //     //   // error: error,
    //     // });
    //   },
    // });
    // });
  }

  subGetBookingDoneClicked: Subscription;
  initAddBookingPlayers() {
    this.subGetBookingDoneClicked = this.teeBookingService
      .getBookingDoneClicked()
      .subscribe((data: any) => {
        if (this.subCheckExistingBooking) return;
        if (data) {
          if (this.addlBookingPlayers?.length > 0) {
            this.subCheckExistingBooking = this.NEWgoProcessBulkAddPlayer().subscribe({
              next: () => {},
              error: error => {
                if (this.subCheckExistingBooking) {
                  this.subCheckExistingBooking.unsubscribe();
                  this.subCheckExistingBooking = null;
                }
                this.teeBookingService.setBookingDoneClicked(false);
              },
              complete: () => {
                if (this.subCheckExistingBooking) {
                  this.subCheckExistingBooking.unsubscribe();
                  this.subCheckExistingBooking = null;
                }
                if (this.subGetBookingDoneClicked) {
                  this.subGetBookingDoneClicked.unsubscribe();
                  this.subGetBookingDoneClicked = null;
                }
                this.teeBookingService.setBookingDoneClicked(false);
              },
            });
          }
        }
      });
  }
}
